/**
 * Chart accent colours — the non-semantic hues charts reach for once the
 * palette slots (primary / success / error / warning) run out.
 *
 * They live here, with the other design tokens, because the same handful of
 * hues was being re-declared in every chart builder: the violet that means
 * "Other" in one donut and "Scope 2" in the next was three separate literals,
 * and a retune had to find all of them. Named by the COLOUR, not by what a
 * given chart uses it for — a token called `trainee` cannot be reused for a
 * waste destination without lying.
 *
 * What does NOT belong here: anything with a semantic palette slot (use
 * `var(--mui-palette-*)`), neutrals and empty-state fills, shadows, and
 * structural values like `transparent`.
 */
export const accents = {
  amber: "#F59E0B",
  amberDark: "#B45309",
  blue: "#175CD3",
  blueDark: "#3538CD",
  coral: "#C9491D",
  emerald: "#19B768",
  emeraldDark: "#15803D",
  magenta: "#BE1E8F",
  navy: "#363F72",
  pink: "#EC4899",
  pinkDark: "#9E165F",
  purple: "#A855F7",
  sky: "#0EA5E9",
  slate: "#94A3B8",
  slateDark: "#64748B",
  teal: "#14B8A6",
  tealDark: "#0F766E",
  violet: "#8B5CF6"
} as const;
